import { DataBean } from "../../DataBean";


export class ClinicalDocument extends DataBean {

  public async getHealthEntryPointTypeConstants(arg: number): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "java.util.List_getHealthEntryPointTypeConstants_Number", [arg]);
  }

  public async getClinicalDocumentCatalog(idAccountSupplier: any, idAccount: any, type: any, year: any, month: any, state: any, idHealthAttentionModality: any, idHealthAttentionService: any, idHealthAttentionSite: any, idHealthAttentionGateEntry: any, idHealthAttentionCause: any, idTriageType: any, idPatientDischargeStatus: any, idHealthAllergies: any, idRiskFactoryType: any, page: any, recordsPerPage: any): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getClinicalDocumentCatalog_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number_Number", [idAccountSupplier, idAccount, type, year, month, state, idHealthAttentionModality, idHealthAttentionService, idHealthAttentionSite, idHealthAttentionGateEntry, idHealthAttentionCause, idTriageType, idPatientDischargeStatus, idHealthAllergies, idRiskFactoryType, page, recordsPerPage]);
  }

  public async createClinicalDocument(idAccount: any, issueDate: any, idEmployee: any): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.health.ClinicalDocument_createClinicalDocument_Number_java.util.Date_Number", [idAccount, issueDate, idEmployee]);
  }
  public async admitClinicalDocument(idClinicalDocument: any, issueDate: any, healthEntryPointType: number, idEmployee: any): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.health.ClinicalDocument_admitClinicalDocument_Number_java.util.Date_Number_Number", [idClinicalDocument, issueDate, healthEntryPointType, idEmployee]);
  }

  public async doTriageToClinicalDocument(idClinicalDocument: any, issueDate: any, idTriageType: any, triageDate: any, idEmployee: any): Promise<any> {
    return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.health.ClinicalDocument_doTriageToClinicalDocument_Number_java.util.Date_Number_java.util.Date_Number", [idClinicalDocument, issueDate, idTriageType, triageDate, idEmployee]);
  }
  public async validateDemographicDataClinicalDocument(bean: any, idEmployee: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.health.ClinicalDocument_validateDemographicDataClinicalDocument_com.quickdataerp.bean.health.ClinicalDocument_Number",
      [
        {
          "DataBeanProperties": bean,
          "DataBeanName": "com.quickdataerp.bean.health.ClinicalDocument"
        }
        , idEmployee
      ]
    );
  }

}